import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function FormSection({ title, description, children }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', xl: '1180px' },
        mx: 'auto',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        px: { xs: 1.5, md: 2 },
        py: { xs: 1.5, md: 1.75 },
        backgroundColor: 'background.paper',
      }}
    >
      <Stack spacing={1.5}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: 0.2 }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.45 }}>
              {description}
            </Typography>
          ) : null}
        </Stack>
        <Divider />
        {children}
      </Stack>
    </Box>
  );
}
